export class JurisdicationResults {
  constructor ( public jurisdictionId: string,
      public jState: string,
      public jurisdiction: string,
      public requestTotal: string) {}

  static createFromRequest(results: any): JurisdicationResults {
        return results == null
          ? null
          : new JurisdicationResults(results.jurisdicationId,
            results.jState,
            results.jurisdiction,
            results.requestTotal);
      }
}



// WEBPACK FOOTER //
// ./src/models/jurisdictionResults.ts